import React, { ChangeEvent, useState } from "react";
import { Button, Grid, Input, Typography } from "@mui/material";
import { MuiFileInput } from "mui-file-input";

const ImageUpload = (props) => {
	const { cb, defa } = props;

	const [previewImage, setPreviewImage] = useState(defa || null);
	const [img, setImg] = useState(null);

	const handleImageChange = (newFile) => {
		const file = newFile;
		setImg(newFile);
		if (file) {
			const reader = new FileReader();

			reader.onloadend = () => {
				const imageData = reader.result;
				cb(imageData);
				setPreviewImage(imageData);
			};
			reader.readAsDataURL(file);
		}
	};

	// Compress Base64 function using pako

	return (
		<Grid container direction="column" alignItems="flex-start" spacing={2}>
			<Grid item width="100%">
				<MuiFileInput
					value={img}
					sx={{ width: "100%" }}
					onChange={handleImageChange}
				/>
			</Grid>
			{previewImage && (
				<Grid item>
					<img src={previewImage} alt="Preview" height={200} />
				</Grid>
			)}
		</Grid>
	);
};

export default ImageUpload;
